import React from 'react';
import { observer } from "mobx-react";
import LinkWithIconV1 from 'ReactApp/Components/LinkWithIconV1/LinkWithIconV1';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartProductCardDeleteV1Props = {
    card: DomainNs.ProductCardInterface,
    cardIndex: number
}

const CartProductCardDeleteV1 = observer((props: CartProductCardDeleteV1Props) => {

    const deleteHandler = (e: React.MouseEvent<HTMLElement>) => {
        showableCartInstance.markAsDeletedCard(props.card);
    }

    return (
        <LinkWithIconV1 {...{
            onClick: deleteHandler,
            classes: [
                'product-card-v6__action-remove',
                'link-with-icon-v1_text-color-type-main',
                'link-with-icon-v1_decoration-type-none',
            ],
            iconProps: {
                svgSpriteId: 'trash-icon',
                width: 18,
                height: 18,
                classes: [
                    'link-with-icon-v1__icon'
                ]
            }
        }} />
    );

})

export default CartProductCardDeleteV1;